import React, { createContext, useState } from "react";

const FilterDeptContext = createContext("All Approvals");

export default FilterDeptContext;